export default __webpack_public_path__ + "static/media/icon-twitter.8d210e0a.svg";